export const template = {
   __typename: 'GridBlockElement',
   id: 'TemplateParityFileList-grid',
   backgroundColor: '#fff',
   columns: [
      {
         __typename: 'ColumnElement',
         id: 'TemplateParityFileList-col0',
         colspan: 12,
         elements: [
            {
               __typename: 'FileListElement',
               id: 'TemplateParityFileList-filelist0',
               fileIds: []
            }
         ]
      }
   ]
}

export const templateData = {}
